import { exactForm } from '../trig/ratios';

export interface ExactValueBadgeHandle {
  element: HTMLSpanElement;
  setValue(v: number): void;
  destroy(): void;
}

export function createExactValueBadge(): ExactValueBadgeHandle {
  const el = document.createElement('span');
  el.className = 'tg-badge';
  return {
    element: el,
    setValue(v) {
      const form = exactForm(v);
      if (form === null) {
        el.textContent = '';
        el.classList.remove('tg-badge-active');
      } else {
        el.textContent = form;
        el.classList.add('tg-badge-active');
      }
    },
    destroy() {
      el.remove();
    },
  };
}
